import { useEffect, useState } from "react"

declare interface NavigatorUA {
    readonly userAgentData?: NavigatorUAData;
}

interface UADataValues {
    readonly mobile?: boolean;
    readonly formFactors?: string[];
}

interface NavigatorUAData {
    getHighEntropyValues(hints: string[]): Promise<UADataValues>;
}


export function useMobileDetection() {
  const [mobileState, setMobileState] = useState(false)
  
  
  async function isMobile(){
    
    if ((navigator as NavigatorUA).userAgentData !== undefined){
      let userAgentDataResponse = await (navigator as NavigatorUA).userAgentData!.getHighEntropyValues(["mobile", "formFactors"]);
      if (userAgentDataResponse !== undefined && userAgentDataResponse.formFactors !== undefined
        && !userAgentDataResponse.formFactors.includes("Desktop")){
        return true;
      }
      if (userAgentDataResponse !== undefined && userAgentDataResponse.mobile !== undefined
        && userAgentDataResponse.mobile === true){
        return true;
      }
    }
    if (navigator.userAgent === undefined){
      return false;
    }
    let userAgentRegexResponse = navigator.userAgent.match(/mobi|tablet|android/i);
    if (userAgentRegexResponse === null){
      return false;
    }
    return true;
  }
  
  const checkIfMobile = async () => {
    let mobileValue = await isMobile();
    setMobileState(mobileValue);
  }
  
  useEffect(() => {
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);



  return { mobileState }
}
